import { useSubscription } from "@/contexts/SubscriptionContext";
import { useRouter } from "next/router";
import { useEffect } from "react";

const SubscriptionGuard = ({ children }: { children: React.ReactNode }) => {
  const { userType, subscriptionLoading } = useSubscription();
  const router = useRouter();

  const restrictedRoutes = [
    "/build",
    "/test",
    "/deploy",
    "/strategy",
    "/scanner",
    "/run-scan",
    "/collab-strategy",
    // "/marketplace", // users can see marketplace without subscription
    "/post-trade",
    "/forward-test-performance",
  ];

  useEffect(() => {
    if (subscriptionLoading) return;

    const isRestricted = restrictedRoutes.some((route) =>
      router.pathname.startsWith(route),
    );

    if (
      userType &&
      userType !== "Pro" &&
      userType !== "Free_access" &&
      isRestricted
    ) {
      router.push("/welcome-tour");
    }
  }, [userType, subscriptionLoading, router.pathname]);

  return <>{children}</>;
};

export default SubscriptionGuard;
